module.exports = __webpack_public_path__ + "media/Video 154.4fe91379.mp4";